export interface InspectionDocument {
  name: string;
  documentId: string;
  creationDateUtc: Date;
  createdBy: string;
  documentType: DocumentType;
  documentTypeName: string;
  shared: boolean;
  templateId: string;
}

export enum DocumentType {
  Report = 0,
  SupportingDocument = 1,
  Certificate = 2,
  FieldReport = 3,
  Invoice = 4 ,
  BillOfLading = 5,
  PackingList = 6,
  RFC = 7,
  ValidTestReport = 8,
  LetterofCredit = 9,
  ProductImage = 10,
  Others = 11,
  InspectionReportPhotos = 12,
  ImportDeclaration = 13,
  ManagementSystemDocuments = 14,
  OtherQualityrelatedDocuments = 15,
  ManufacturersProductSpecifications = 16,
  ManufacturerDeclaration = 17,
  CompetitorProductCertificatesRegistrationsOrLicences = 18,
  NominationRiskAssessmentForm = 19,
  QualityCertificate = 20,
  ManualCertificate = 21,
  HomologationCertificate =22,
  FactoryAuditReport = 23,
  DesignDrawing = 24,
  WorkshopInspectionReport = 25,
  PhotoReport = 26,
}
